import React, { useMemo } from 'react';
import styles from './TimezoneSelect.module.scss';

const COMMON_TIMEZONES = [
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
  'America/Toronto', 'America/Vancouver', 'America/Sao_Paulo', 'America/Argentina/Buenos_Aires',
  'Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Madrid', 'Europe/Rome',
  'Europe/Amsterdam', 'Europe/Zurich', 'Europe/Stockholm', 'Europe/Helsinki', 'Europe/Moscow',
  'Asia/Dubai', 'Asia/Kolkata', 'Asia/Singapore', 'Asia/Shanghai', 'Asia/Tokyo', 'Asia/Seoul',
  'Asia/Hong_Kong', 'Asia/Bangkok',
  'Australia/Sydney', 'Australia/Melbourne', 'Pacific/Auckland',
  'Africa/Johannesburg', 'Africa/Cairo',
  'UTC',
];

interface Props {
  value: string;
  onChange: (tz: string) => void;
}

export const TimezoneSelect: React.FC<Props> = ({ value, onChange }) => {
  const sortedTimezones = useMemo(() => {
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tzSet = new Set([browserTz, ...COMMON_TIMEZONES]);
    return Array.from(tzSet).sort();
  }, []);

  return (
    <div className={styles.wrapper}>
      <label className={styles.label}>Timezone</label>
      <select className={styles.select} value={value} onChange={(e) => onChange(e.target.value)}>
        {sortedTimezones.map((tz) => (
          <option key={tz} value={tz}>
            {tz.replace(/_/g, ' ')}
          </option>
        ))}
      </select>
    </div>
  );
};
